/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class FileUpload implements IDirective {
        public controller = ["$scope", "fileUploadDownloadService", "processDocumentService", "ModalService", FileUploadController];
        public controllerAs = "controller";
        public templateUrl = "./app/views/directives/fileUpload.html";
        public restrict: string = "E";

        public scope: any = {
            process: "=",
            documentIds: "=",
            documentId: "=",
            refresh: "=",
            documentConfiguration: "=",
            systemDocumentConfiguration: "=",
            schemaPropertyUniqueId: "=",
            manageDocumentConfigUniqueId: "=",
            commentThreadConfigUniqueId: "=",
            userActionInfoUniqueId: "=",
            reviewConfigurationUniqueId: "=",
            processEventConfigUniqueId: "=",
            documentsAllowed: "=",
            isReadonly: "=",
            changeCallback: "=",
            isTemporary: "=",
            titleTagDescription: "="
        };

        public link(scope: IFileUploadScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: FileUploadController): void {
        }
    }

    export interface IFileUploadScope extends ng.IScope {
        process: Wars.Domain.Model.Dtos.ProcessDto,
        documentIds: string[];
        documentId: string;
        refresh: boolean;
        internalDocumentIds: string[];
        documents: Wars.Domain.Model.Dtos.DocumentDto[];
        model: models.FileUploadModel;
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        schemaPropertyUniqueId: string;
        manageDocumentConfigUniqueId: string;
        commentThreadConfigUniqueId: string;
        userActionInfoUniqueId: string;
        reviewConfigurationUniqueId: string;
        processEventConfigUniqueId: string;
        documentsAllowed: number;
        isReadonly: boolean;
        fileUploadProgress: number;
        errorMessage: string;
        changeCallback: (model: models.FileUploadModel) => void;
        getFaClass(filename: string): string;
        addDocument(): void;
        editDocument(index: number): void;
        deleteDocument(index: number): void;
        getUniqueId(): string;
        isTemporary: boolean;
        titleTagDescription: string;
    }

    export class FileUploadController implements IController {
        constructor(
            private scope: IFileUploadScope,
            private fileUploadDownloadService: services.FileUploadDownloadService,
            private processDocumentService: services.ProcessDocumentService,
            private modalService: any)
        {
            this.scope.addDocument = () => {
                this.showUploadModal([]);
            };
            this.scope.editDocument = (index: number) => {
                this.showUploadModal([this.scope.internalDocumentIds[index]]);
            };
            this.scope.deleteDocument = (index: number) => {
                this.deleteDocument(index);
            };
            this.scope.getUniqueId = () => { return this.getUniqueId(); }

            this.scope.$watch("documentId", () => {
                this.initialize();
            });

            this.scope.$watch("documentIds", () => {
                this.initialize();
            });

            if (this.scope.refresh !== undefined) {
                this.scope.$watch("refresh", (value) => {
                    if (value) {
                        this.initialize();
                    }
                    this.scope.refresh = false;
                });
            }

            this.initialize();
        }

        private initialize() {
            this.scope.internalDocumentIds = [];
            if (this.scope.documentId) {
                this.scope.internalDocumentIds = [this.scope.documentId];
            }
            if (this.scope.documentIds) {
                this.scope.internalDocumentIds = this.scope.documentIds;
            }

            this.scope.model = new models.FileUploadModel();
            this.scope.model.documents = [];

            if (this.scope.internalDocumentIds) {
                for (var i = 0; i < this.scope.internalDocumentIds.length; i++) {
                    var document = this.processDocumentService.getDocumentById(this.scope.process, this.scope.internalDocumentIds[i]);
                    if (document) {
                        this.scope.model.documents.push(document);
                    }
                }
            }
        }

        private getUniqueId(): string {
            if (this.scope.schemaPropertyUniqueId) return this.scope.schemaPropertyUniqueId;
            if (this.scope.manageDocumentConfigUniqueId) return this.scope.manageDocumentConfigUniqueId;
            if (this.scope.commentThreadConfigUniqueId) return this.scope.commentThreadConfigUniqueId;
            if (this.scope.userActionInfoUniqueId) return this.scope.userActionInfoUniqueId;
            if (this.scope.reviewConfigurationUniqueId) return this.scope.reviewConfigurationUniqueId;
            if (this.scope.processEventConfigUniqueId) return this.scope.processEventConfigUniqueId;

            return undefined;
        }

        private getDocumentConnections(): Wars.Domain.Model.Dtos.DocumentConnectionsDto {
            return {
                processId: this.scope.process.id,
                schemaPropertyUniqueId: this.scope.schemaPropertyUniqueId,
                userActionInfoUniqueId: this.scope.userActionInfoUniqueId,
                manageDocumentConfigUniqueId: this.scope.manageDocumentConfigUniqueId,
                commentThreadConfigUniqueId: this.scope.commentThreadConfigUniqueId,
                reviewConfigurationUniqueId: this.scope.reviewConfigurationUniqueId,
                processEventConfigUniqueId: this.scope.processEventConfigUniqueId
            }
        }

        private deleteDocument(index: number): void {
            var documentToDelete = this.scope.model.documents[index];
            this.fileUploadDownloadService.deleteDocument(documentToDelete.id)
                .then(() => {
                    this.scope.model.documents.remove(documentToDelete);
                    this.processDocumentService.updateProcessDocuments(this.scope.process, [], [documentToDelete.id]).then(() => {
                        if (this.scope.changeCallback) {
                            this.scope.changeCallback(this.scope.model);
                        }
                    });
                });
        }

        private showUploadModal(documentIds: string[]): void {
            this.scope.model.errorMessage = undefined;
            this.scope.model.fileUploadProgress = undefined;

            var docsHiddenFromModal: Wars.Domain.Model.Dtos.DocumentDto[];
            if (!documentIds) {
                if (this.scope.model && this.scope.model.documents) {
                    docsHiddenFromModal = this.scope.model.documents;
                }
            } else {
                docsHiddenFromModal = Enumerable.from(this.scope.model.documents)
                    .where(i => documentIds.indexOf(i.id) === -1)
                    .toArray();
            }

            var modalModel = new models.FileUploadModel();
            modalModel.documents = Enumerable.from(this.scope.model.documents).toArray();

            this.modalService.showModal({
                templateUrl: "./app/views/modals/fileUploadModal.html",
                controller: "fileUploadModalController",
                size: "lg",
                inputs: {
                    documentIds,
                    process: this.scope.process,
                    documentConfiguration: this.scope.documentConfiguration,
                    systemDocumentConfiguration: this.scope.systemDocumentConfiguration,
                    uniqueIdentifier: this.getUniqueId(),
                    model: modalModel
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    // Only true if not a cancel
                    if (result) {
                        this.fileUploadDownloadService.updateDocumentMetadata(
                            modalModel.documents,
                            this.getDocumentConnections(),
                            documentIds,
                            this.scope.isTemporary).then(
                        (documents) => {
                            this.scope.model.documents = documents.concat(docsHiddenFromModal);

                            this.processDocumentService.updateProcessDocuments(this.scope.process, documents, documentIds).then(
                            () => {
                                if (this.scope.changeCallback) {
                                    this.scope.changeCallback(this.scope.model);
                                }
                            });
                        });
                    }
                });
            });
        }
    }
}

warsApp.registerDirective('FileUpload', []);